/*
  Collection and search filtering without page reloads, using the Section Rendering API.
  Progressive enhancement: without JS the filter form submits normally.
*/
(() => {
  'use strict';

  const section = document.querySelector('[data-facets-section]');
  if (!section) return;

  const sectionId = section.dataset.sectionId;
  const formId = `FacetForm-${sectionId}`;
  const REGIONS = ['[data-facets-results]', '[data-facets-filters]', '[data-facets-active]', '[data-facets-count]', '[data-facets-badge]'];
  let controller;

  const debounce = (fn, wait) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), wait);
    };
  };

  function queryString() {
    const form = document.getElementById(formId);
    const params = new URLSearchParams();
    if (!form) return '';
    new FormData(form).forEach((value, key) => {
      if (String(value).trim() !== '') params.append(key, value);
    });
    return params.toString();
  }

  async function render(url, push = true) {
    controller?.abort();
    controller = new AbortController();
    section.classList.add('is-loading');
    try {
      const target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', sectionId);
      const res = await fetch(target, { signal: controller.signal });
      if (!res.ok) throw new Error(String(res.status));
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

      REGIONS.forEach((selector) => {
        const fresh = doc.querySelector(selector);
        const current = section.querySelector(selector);
        if (!current) return;
        if (fresh) {
          current.innerHTML = fresh.innerHTML;
          if (fresh.hasAttribute('hidden')) current.setAttribute('hidden', '');
          else current.removeAttribute('hidden');
        }
      });

      if (push) window.history.pushState({ facets: true }, '', url);
    } catch (error) {
      if (error.name !== 'AbortError') window.location.href = url;
    } finally {
      section.classList.remove('is-loading');
    }
  }

  const submit = () => {
    const qs = queryString();
    render(qs ? `${window.location.pathname}?${qs}` : window.location.pathname);
  };
  const submitSoon = debounce(submit, 300);
  const submitPrice = debounce(submit, 700);

  const belongsToForm = (el) => el.closest(`#${formId}`) || el.getAttribute('form') === formId;

  section.addEventListener('change', (event) => {
    const el = event.target;
    if (!belongsToForm(el) || el.type === 'number') return;
    submitSoon();
  });

  section.addEventListener('input', (event) => {
    const el = event.target;
    if (el.type === 'number' && belongsToForm(el)) submitPrice();
  });

  section.addEventListener('submit', (event) => {
    if (event.target.id !== formId) return;
    event.preventDefault();
    submit();
  });

  section.addEventListener('click', (event) => {
    const link = event.target.closest('[data-facet-link]');
    if (!link) return;
    event.preventDefault();
    render(link.href);
  });

  window.addEventListener('popstate', () => render(window.location.href, false));
})();
